const initalState = null;

const pilDetailsReducer = (state = initalState, action) => {
  const { type, data } = action;
  switch (type) {
    case "HANDLE_PIL_VALUE":
      return data;
    default:
      return state;
  }
};

export { pilDetailsReducer };
